import { useState } from "react";
import PayRollOverView from "./PayRollOverView";
import PayRollSalary from "./PayRollSalary";
import PayRollHistry from "./PayRollHistry";

export default function PayRollDashboard({ employee }) {
    const [activeTab, setActiveTab] = useState("overview");

    if (!employee) return null;
    
    const basic = {
        name: `${employee.workInformation?.firstName || ""} ${employee.workInformation?.lastName || ""}`,
        workLocation: employee.departmentName || "-",
        email: employee.officeEmail || "-",
        designation: employee.workInformation?.designation || "-",
        mobile: employee.personalDetails?.mobile || "-",
        department: employee.departmentName || "-",
        dateOfJoining: employee.workInformation?.joiningDate
            ? new Date(employee.workInformation.joiningDate).toLocaleDateString()
            : "-",
        portalAccess: true,
        gender: employee.personalDetails?.gender || "-"
    };

    const personal = {
        dob: employee.personalDetails?.dob
            ? new Date(employee.personalDetails.dob).toLocaleDateString()
            : "-",
        email: employee.personalDetails?.personalEmail || "-",
        fatherName: employee.personalDetails?.guardianName || "-",
        address: employee.personalDetails?.address || "-",
        pan: employee.personalDetails?.pan || "-",
        differentlyAbled: employee.personalDetails?.differentlyAbled || "None"
    };
    
    const payrollList = employee.payroll || [];
    const latestSalary = payrollList[0] || {}; 

    return (
        <div className="bg-white p-2 rs:p-6 rounded shadow-lg mx-auto ">
            <div className="flex border-b border-gray-200 mb-6">
                <button
                    onClick={() => setActiveTab("overview")}
                    className={`px-2 sm:px-4 py-2 font-semibold rounded-t-lg  text-[12px] lg:text-sm ${activeTab === "overview"
                        ? "bg-blue-50 text-blue-600 border-b-2 border-blue-600"
                        : "text-gray-500"
                        }`}
                >
                    Overview
                </button>
                <button
                    onClick={() => setActiveTab("salary")}
                    className={`px-2 sm:px-4 py-2 font-semibold rounded-t-lg  text-[12px] lg:text-sm ${activeTab === "salary"
                        ? "bg-blue-50 text-blue-600 border-b-2 border-blue-600"
                        : "text-gray-500"
                        }`}
                >
                    Salary Details
                </button>
                <button
                    onClick={() => setActiveTab("salaryHistry")}
                    className={`px-2 sm:px-4 py-2 font-semibold rounded-t-lg text-[12px] lg:text-sm ${activeTab === "salaryHistry"
                        ? "bg-blue-50 text-blue-600 border-b-2 border-blue-600"
                        : "text-gray-500"
                        }`}
                >
                    Salary History
                </button>
            </div>

            {activeTab === "overview" && (
                <div className="space-y-6">
                    <PayRollOverView basic={basic} personal={personal} />
                </div>
            )}

            {activeTab === "salary" && (
                <div className="space-y-2">
                    <PayRollSalary
                        salary={latestSalary}
                        employeeId={employee.employeeId}
                        username={`${employee.workInformation?.firstName || ""} ${employee.workInformation?.lastName || ""}`}
                        workEmail={employee.officeEmail || "-"}
                        personalEmail={employee.personalDetails?.personalEmail || "-"}
                        annual={payrollList}
                    />

                </div>
            )}

            {activeTab === "salaryHistry" && (
                <div className="space-y-2">
                    <PayRollHistry
                        employeeId={employee.employeeId}
                        salary={payrollList}
                        username={`${employee.workInformation?.firstName || ""} ${employee.workInformation?.lastName || ""}`}
                        workEmail={employee.officeEmail || "-"}
                        personalEmail={employee.personalDetails?.personalEmail || "-"}
                        employeeStatus ={employee.employeeStatus || "-"}
                    />
                </div>
            )}
        </div>
    );
}
